import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router"
import { ConversationPanel } from "@/components/conversation/ConversationPanel"

export const Route = createFileRoute("/$orgSlug/$eventSlug/t/$ticketId")({
  component: ConversationView,
})

function ConversationView() {
  const params = useParams({ from: "/$orgSlug/$eventSlug/t/$ticketId" })
  const navigate = useNavigate()
  return (
    <ConversationPanel
      ticketId={params.ticketId}
      onBack={() =>
        navigate({
          to: "/$orgSlug/$eventSlug/tickets",
          params: { orgSlug: params.orgSlug, eventSlug: params.eventSlug },
        })
      }
    />
  )
}
